<template>
  <w-modal
    v-model="value"
    variant="error"
    @close="close"
  >
    <template #header>
      <h1 class="sm:text-xl text-2xl text-center">
        取消訂單
      </h1>
    </template>
    <div class="flex">
      <i v-if="!$breakpoints.sm" class="icon-alert-circle mr-4 mt-1 text-xl">
        <span class="path1" />
        <span class="path2" />
        <span class="path3" />
      </i>
      <p class="sm:text-lg text-black text-xl">
        確定取消 {{ orderName }} 的訂單嗎？
      </p>
    </div>
    <template #footer>
      <section class="flex items-center justify-end sm:justify-center">
        <w-button
          :disabled="canceling"
          class="disabled:bg-red-50 hover:text-red-600 mr-2 sm:flex-grow text-red-500"
          variant="text"
          @click="close"
        >
          保留訂單
        </w-button>
        <w-button
          :disabled="canceling"
          :loading="canceling"
          class="sm:flex-grow"
          variant="error"
          @click="cancel"
        >
          確認取消
        </w-button>
      </section>
    </template>
  </w-modal>
</template>

<script>
import CancelOrder from './CancelOrder';

export default CancelOrder;
</script>

<style lang="scss" scoped>
@import 'CancelOrder';
</style>
